import { useLanguage } from "@/context/LanguageContext";
import emblem from "@/assets/clan-emblem.png";

// The traditional Mhic Dhòmhnaill lockup: heraldic clan emblem +
// "The McDonalds" in a Gaelic uncial + the "One Clan · Many Names" tagline.
export function BrandLogo({ size = "header" }) {
  const { t } = useLanguage();
  const parts = t.brandTagline.split("·").map((s) => s.trim());
  const emblemCls =
    size === "footer" ? "h-11 w-11" : "h-9 w-9 sm:h-11 sm:w-11";

  return (
    <span className="group flex items-center gap-2 sm:gap-3">
      <span
        role="img"
        aria-label="Clan MacDonald heraldic emblem — a Highland galley within a Celtic knot"
        className={`${emblemCls} shrink-0 bg-clan-accent transition-transform duration-700 ease-out group-hover:-rotate-6`}
        style={{
          WebkitMaskImage: `url(${emblem})`,
          maskImage: `url(${emblem})`,
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskSize: "contain",
          maskSize: "contain",
          WebkitMaskPosition: "center",
          maskPosition: "center",
        }}
      />
      <span className="flex min-w-0 flex-col leading-none">
        <span className="brand-wordmark whitespace-nowrap text-[12.5px] tracking-normal text-clan-accent sm:text-lg sm:tracking-wide">
          The McDonalds
        </span>
        <span className="mt-1 font-mono text-[8.5px] uppercase tracking-[0.18em] text-clan-muted sm:text-[9px] sm:tracking-[0.3em]">
          <span className="flex max-w-[112px] flex-col leading-tight sm:hidden">
            <span className="truncate">{parts[0]} ·</span>
            <span className="truncate">{parts[1] || ""}</span>
          </span>
          <span className="hidden whitespace-nowrap sm:inline">{t.brandTagline}</span>
        </span>
      </span>
    </span>
  );
}
